import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';

import { map } from 'rxjs/operators';
import { getConstants } from '../infrastructure/base-state/constants/constants.selectors';

@Injectable({
  providedIn: 'root'
})
export class ConstantsTypeTranslatorService {
  private translate = inject(TranslateService);
  private store = inject(Store);

  public getTranslation(value: string, constantType: string) {
    return this.store.select(getConstants).pipe(
      map(constants => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return (
          (value &&
            constants?.[constantType]?.find(
              constantsValue => constantsValue.value === value
            )?.name) ||
          this.translate.instant('NOT_AVAILABLE_L')
        );
      })
    );
  }
}
